import React, {Component} from 'react'
import { money } from '../../utils/helpers'
import { getProductCollections } from '../../utils/Product'

class ProductTile extends Component {
  constructor(props) {
    super(props)
    // const subtitles = ['Classic', 'Arc En Ciel', 'Essential', 'Spectator', 'Sheen', 'Patent', 'Patents', 'Monogram', 'Debossed']
    const badges = ['Collaboration']
    this.state = {
      data: props.props,
      currentVariant: props.props.variants[0],
      subtitles: props.props.tags.filter((tag) => window.productTileSubtitles.includes(tag)),
      badges: props.props.tags.filter((tag) => badges.includes(tag)),
      swiper: null,
      media: props.props.media.filter((m) => m.media_type.toLowerCase() == 'image')
    }
    
    this.swiperRef = React.createRef()
    console.log('Proudct Tile', this.state.data, this.state.currentVariant)
  }

  imageUrl(url, related=false) {
    return url.replace('.jpg?', `.jpg?width=${related ? 380 : 480}&`).replace('.png?', `.png?width=${related ? 380 : 480}&`).replace('.webp?', `.webp?width=${related ? 380 : 480}&`)
  }

  productUrl() {
    return `${this.state.data.collectionHandle ? '/collections/' + this.state.data.collectionHandle : ''}/products/${this.state.data.handle}`
  }

  swatchStyle(sku) {
    return { backgroundImage: `url(${location.origin}/cdn/shop/files/${sku.split('-')[sku.split('-').length - 1]}_PDP.jpg?width=16)` }
  }

  backSlides(swiper) {
    const itemsWrapper = swiper.wrapperEl.closest('.related-products')
    const relatedItems = itemsWrapper ? itemsWrapper.querySelectorAll('[data-product-swiper]') : []
    relatedItems.forEach((relatedItem) => {
      if(relatedItem.swiper.wrapperEl != swiper.wrapperEl) {
        relatedItem.swiper.slideTo(0, 0, false)
      }
    })
  }

  componentDidMount() {
    this.swiperRef.current.closest('[product-tile]').setAttribute('product-tile', true)
    if(this.state.media.length > 1) {
      new Swiper(this.swiperRef.current, {
        speed: 500,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          navigationPrev: (swiper) => {
            this.backSlides(swiper)
          },
          navigationNext: (swiper) => {
            this.backSlides(swiper)
          },
          afterInit: (swiper) => {
            this.swiperRef.current.querySelector('.swiper-button-prev').addEventListener('click', (e) => e.stopPropagation())
            this.swiperRef.current.querySelector('.swiper-button-next').addEventListener('click', (e) => e.stopPropagation())
          },
        },
      })
    }

    if(typeof this.state.data.collectionLoaded == 'undefined' || !this.state.data.collectionLoaded) {
      getProductCollections((product) => {
        if(product) {
          this.setState({
            data: Object.assign(this.state.data, {
              siblings: typeof product.collections != 'undefined' && product.collections.edges.filter((edge) => edge.node.title.includes('_linked')).length ? product.collections.edges.filter((edge) => edge.node.title.includes('_linked'))[0].node.products.edges.filter((edge) => edge.node.onlineStoreUrl).map((edge) => edge.node.variants.edges[0].node.sku) : []
            })
          }) 
        }
      }, this.state.data.id)
    }
  }

  render() {
    return (
      <div className=''>
        <div className='relative mb-3 lg:mb-6'>
          <div className='relative group' data-product-swiper={this.state.data.id} ref={this.swiperRef}>
            {
              this.state.data.tags.includes('in grid promo') ?
                <div className='relative lg:h-0 lg:pb-[125%] overflow-hidden bg-grid'>
                  <div className='p-3 lg:p-0 lg:absolute lg:inset-6 flex flex-col justify-between gap-10'>
                    {this.state.data.grid.title && <div className='text-white text-[1.25rem] lg:text-[2rem] leading-[1.2] lg:leading-[1.125] uppercase font-bold'>{this.state.data.grid.title}</div>}
                    {this.state.data.grid.text && <div className='text-white text-sm leading-4' dangerouslySetInnerHTML={{ __html: this.state.data.grid.text }} />}
                  </div>
                </div>:
                <a className='swiper-wrapper bg-white' href={this.productUrl()} aria-label={this.state.data.title}>
                {
                  this.state.media.map((image, index) => 
                    <div className='swiper-slide h-full'
                      data-index={index}
                      key={`${this.state.data.id}-${index}`}>
                      <div className='relative h-0 pb-[125%] overflow-hidden'>
                        {index == 0 && !this.state.data.related ? 
                          <img className='absolute w-full h-full top-1/2 left-1/2 object-cover transform -translate-x-1/2 -translate-y-1/2' src={this.imageUrl(image.preview_image.src, this.state.data.related)} alt={image.alt ? image.alt : `${this.state.data.title} - image - ${index}`} fetchpriority='high' /> : 
                          <img className='absolute w-full h-full top-1/2 left-1/2 object-cover transform -translate-x-1/2 -translate-y-1/2' src={this.imageUrl(image.preview_image.src, this.state.data.related)} alt={image.alt ? image.alt : `${this.state.data.title} - image - ${index}`} loading='lazy' />
                        }
                      </div>
                    </div>
                  )
                }
              </a>
            }
            
            { this.state.media.length > 1 && <div className="swiper-button-prev !text-second !h-auto after:!hidden !top-auto !bottom-4 !left-4 !hidden lg:group-hover:!flex" 
              dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-arrow'] }} /> }
            { this.state.media.length > 1 && <div className="swiper-button-next !text-second !h-auto after:!hidden !top-auto !bottom-4 !right-4 !hidden lg:group-hover:!flex" dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-arrow-right'] }} /> }
            { this.state.media.length > 1 && <div className="swiper-pagination !block lg:!hidden !static mt-1 !h-0.5" /> }
          </div>

          <div className='product-card-badges absolute top-0 left-0 right-24 flex gap-2 flex-wrap p-2 lg:p-3 z-[1] w-max'>
            {
              this.state.data.tags.includes('Final Sale') && 
              <span className='bg-lss-navy bg-opacity-10 text-sm leading-4 text-black px-2 py-1 capitalize'>Final Sale</span>
            }
            {
              this.state.data.comparePrice && this.state.data.comparePrice > this.state.data.price && !this.state.data.tags.includes('Final Sale') &&
              <span className='bg-lss-navy bg-opacity-10 text-sm leading-4 text-black px-2 py-1 capitalize'>Sale</span>
            }
            {
              this.state.badges.map((badge, index) => 
                <span className='bg-lss-navy bg-opacity-10 text-sm leading-4 text-black px-2 py-1 capitalize' key={`product-badge-${this.state.data.id}-${index}`}>{ badge }</span>
              )
            }
          </div>
          {/* { this.state.data.tags.includes('Recycled') && <span className='product-card-recycle absolute bottom-1.5 right-1.5 lg:bottom-0 lg:top-3 lg:right-3 z-[1]' dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-recycle'] }} /> } */}
        </div>
        {this.state.subtitles.length > 0 && !this.state.data.tags.includes('in grid promo') && <div className='flex text-sm leading-4 mb-2'>{ this.state.subtitles.join(', ') }</div>}

        {
          this.state.data.tags.includes('in grid promo') ?
            null :
            <a className='flex flex-col lg:flex-row justify-between gap-2 lg:gap-6 lg:mb-2 no-underline' href={this.productUrl()}>
              <h3 className='text-base uppercase'>{ this.state.data.title }</h3>
              <span className='flex items-center gap-4 text-sm leading-4 lg:text-base lg:leading-6'>
                { money(this.state.data.price) }
                { this.state.data.tags.includes('SOLD OUT') && <span className='text-xs lg:text-sm'>Sold Out</span> }
                {this.state.data.siblings.length > 0 && <span className='inline-block lg:hidden'>Colors <sup>{this.state.data.siblings.length}</sup></span>}
              </span>
            </a>
        }
        
        {
          this.state.data.options_by_name.Color && this.state.data.siblings.length > 0 &&
          <div className='hidden lg:flex items-center gap-2'>
            {
              this.state.data.siblings.map((sibling, index) => {
                if(this.state.data.siblings.length <= 5 || (this.state.data.siblings.length > 5 && index < 4))
                  return <span className='rounded-full bg-no-repeat	bg-cover bg-center overflow-hidden w-4 h-4' style={ this.swatchStyle(sibling) } key={`${this.state.data.id}-swatch-${index}`}></span>
                else
                  return ''
              })
            }
            {
              this.state.data.siblings.length > 5 && <a className='font-tinos text-sm leading-4 no-underline hover:underline' href={this.productUrl()}>+ {this.state.data.siblings.length - 4} Colors</a>
            }
          </div>
        }
        {
          this.state.data.showATC && <button className='w-full button !bg-fore !text-back hover:!border-fore hover:!bg-transparent hover:!text-fore mt-3 px-4 !text-sm !leading-4' data-product-add onClick={(e) => {
            window.addLineItems(null, [{
              'id': this.state.currentVariant.id.replace('gid://shopify/ProductVariant/', ''), 
              'quantity': 1,
              'properties': {
                'Final Sale': this.state.data.tags.includes('Final Sale') ? 'Yes' : null
              }
            }], true, e.target);e.target.disabled = true;
          }}>Add to bag</button>
        }
      </div>
    )
  }
}
export default ProductTile